import classNames from "classnames";
import React from "react";

interface Props {
  classNames?: string;
}

export const SomethingUnexpectedHappenedMessageBox = (props: Props) => {
  const classes = classNames("message ui red", props.classNames);
  return (
    <div className={classes}>
      {RESX.GeneralLabels.SomethingUnexpectedHappened}
    </div>
  );
};
